import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'burnTokenLogo'
})
export class BurnTokenLogoPipe implements PipeTransform {

  private tokenList = {
    'USDC': 'assets/img/USDC.png',
    'USDT': 'assets/img/USDT.png',
    'BUSD': 'assets/img/BUSD.png',
    'WETH': 'assets/img/WETH.png',
    'WBTC': 'assets/img/WBTC.png',
  }
  private DEFAULT = 'assets/img/BNB.png';

  transform(value: string): string {
    const logo = this.tokenList[value] ?? this.DEFAULT;
    return logo;
  }

}
